import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';

var TabsComponent = /** @class */ (function (_super) {
    __extends(TabsComponent, _super);
    function TabsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabsComponent = __decorate([
        Component({
            name: 'ui-tabs',
        })
    ], TabsComponent);
    return TabsComponent;
}(Mixins(MagicConfigMixin)));

export default TabsComponent;
